import Vue from 'vue'

// check why import axiosFactory is needed
import axiosFactory from '../../../plugins/axiosFactory'
import axios from 'axios/index'
Vue.use(axiosFactory, axios)

var resource = Vue.axiosFactory.create({baseURL: 'app/subscriptions/'})

export default {
  getBillingDetails (subscriptionId) {
    return resource({method: 'get', url: `/get_billing_details/${subscriptionId}`})
  },
  cancelSubscription () {
    return resource({method: 'post', url: '/cancel'})
  },
  renewSubscription () {
    return resource({method: 'post', url: '/renew'})
  },
  pauseSubscription () {
    return resource({method: 'post', url: '/pause'})
  },
  unpauseSubscription () {
    return resource({method: 'post', url: '/unpause'})
  },
  upgradeSubscription (planId, newQuantity) {
    return resource({method: 'post', url: '/upgrade', data: {planId, newQuantity}})
  },
  getCancelledSubscription () {
    return resource({method: 'get', url: ''})
  },
  addCancellationInfo(reason) {
    return resource({method: 'post', url: 'add_cancellation_info', data: {reason}})
  }
}
